
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 299.997 299.997"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"150.437","cy":"110.572","r":"24.149"}}),_c('path',{attrs:{"d":"M149.996 0C67.157 0 .001 67.158.001 149.997c0 82.837 67.156 150 149.995 150s150-67.163 150-150C299.996 67.158 232.835 0 149.996 0zm-.311 68.678c.106 0 .21-.005.314-.01.104.005.207.01.314.01 25.274.399 45.834 21.288 45.834 46.568 0 30.908-33.024 62.205-46.148 73.419-.877-.75-1.849-1.595-2.889-2.521-.018-.016-.034-.029-.049-.044-14.524-12.906-43.209-42.045-43.209-70.854-.001-25.28 20.561-46.168 45.833-46.568zm.965 163.572c-27.663 0-55.669-7.936-55.669-23.098 0-10.641 13.79-17.717 31.569-20.995a219.685 219.685 0 009.55 9.049c-19.366 2.163-30.744 8.294-30.744 11.943 0 4.484 17.195 12.724 45.294 12.724 28.099 0 45.297-8.24 45.297-12.724 0-3.724-11.858-10.009-31.927-12.052a220.98 220.98 0 009.627-9.142c18.313 3.188 32.674 10.335 32.674 21.197 0 15.162-28.006 23.098-55.671 23.098z"}})])
          )
        }
      }
    